import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { TextMedium } from 'lib/common/text';

export const ActiveDot = styled.div`
    border-radius: 50%;
    height: 6px;
    margin-right: 12px;
    width: 6px;
    ${({ isActive, theme }) =>
        isActive &&
        css`
            background-color: ${theme.color.green};
        `};
`;

export const Container = styled.div`
    cursor: pointer;
    z-index: 200;
    height: 100%;
    ${({ isActive, backColor, theme }) => css`
        background-color: ${isActive ? theme.color.grayDark : backColor ? backColor : theme.color.black};
    `}
`;

export const TogglerContainer = styled.div`
    width: 12px;
    height: 12px;
    margin-left: 6px;
    position: relative;
    top: -1px;
`;

const Text = styled(TextMedium)`
    text-transform: uppercase;
    user-select: none;
`;

export const ItemContainer = styled.div`
    display: flex;
    background-color: inherit;
    align-items: center;
    height: 100%;
    min-height: 100%;
    position: relative;
    ${({ theme, isActive, backColor }) => css`
        border: 1px solid ${backColor ? backColor : theme.color.black};
        padding: 0 ${theme.size.large};
        :first-of-type {
            background-color: ${isActive && backColor ? theme.color.ReportsMenuSelected : 'inherit'};
        }
        :not(:last-child) {
            border-bottom: 0;
        }
    `};
    ${({ isActive, backColor }) =>
        isActive &&
        backColor &&
        css`
            border-top: 0;
        `};
`;

export const Item = styled(Text)`
    white-space: nowrap;
`;

export const Name = styled(Text)`
    opacity: 0.5;
    margin-right: 6px;
`;

export const Label = styled(Text)`
    white-space: nowrap;
    font-weight: bold;
`;

export const DropdownContainer = styled.div`
    z-index: 310;
    height: inherit;
`;
